import { createContext, useState } from "react";

import { getInitialLocationState } from "utils/canadaWeatherLocations";

export const CalculatorContext = createContext();

const CalculatorContextProvider = ({ children }) => {
    const [calculationResults, setCalculationResults] = useState({});
    const [calculatorData, setCalculatorData] = useState({
        project_name: "",
        user_email: "",
        dateMode: "Annual",
        year: "2025",
        gasuse_total: 2500,
        gasuse_total_units: "m3",
        gas_period_start: "2025-01-01",
        gas_period_end: "2025-12-31",
        dhw_monthly: 20,
        dhw_monthly_units: "m3",
        // balance_point: 16, Now calculated by back-end
        furnace_eff: 95,
        derate: 20,
        indoor_temp_heat: 22,
        home_type: "detached",
        home_age: "1960 - 1990",
        energy_upgrades: "none",
        use_advanced_weather: false,
        ...getInitialLocationState(),
        heatpumpcap_5: 0,
        heatpumpcap_17: 0,
        heatpumpcap_47: 0,
    });

    return (
        <CalculatorContext.Provider
            value={{
                calculationResults,
                setCalculationResults,
                calculatorData,
                setCalculatorData,
            }}
        >
            {children}
        </CalculatorContext.Provider>
    );
};

export default CalculatorContextProvider;
